import { useState } from "react";
import { useOverviewHistory, type HistoryRange } from "@/hooks/use-overview-history";
import MiniChart from "@/pages/overview/mini-chart";

const RANGES: { label: string; value: HistoryRange }[] = [
  { label: "15M", value: "15m" },
  { label: "1H", value: "1h" },
  { label: "6H", value: "6h" },
  { label: "1D", value: "1d" },
  { label: "3D", value: "3d" },
  { label: "7D", value: "7d" },
];

export default function OverviewCharts() {
  const [range, setRange] = useState<HistoryRange>("1h");
  const { data: rows } = useOverviewHistory(range);

  const netValues = rows?.map((r) => r.net) ?? [];
  const equityValues = rows?.map((r) => r.equity) ?? [];
  const sfValues = rows?.map((r) => r.safe_factor) ?? [];

  return (
    <div className="bg-surface border border-border rounded-lg p-3 mb-4">
      {/* Range toolbar */}
      <div className="flex items-center gap-1.5 flex-wrap mb-2.5">
        <span className="text-muted text-[0.75rem] uppercase tracking-wider mr-1">
          Range
        </span>
        {RANGES.map(({ label, value }) => (
          <button
            key={value}
            onClick={() => setRange(value)}
            className={[
              "px-2.5 py-0.5 rounded text-[0.75rem] font-medium border cursor-pointer transition-colors",
              range === value
                ? "bg-success/10 border-success text-success"
                : "border-[#333] text-[#aaa] hover:border-[#555] hover:text-text",
            ].join(" ")}
          >
            {label}
          </button>
        ))}
      </div>

      {/* Chart row — 3 cols desktop, stacked mobile */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <MiniChart label="Net PnL" values={netValues} metric="net" decimals={4} />
        <MiniChart label="Equity" values={equityValues} metric="equity" decimals={2} />
        <MiniChart label="Safe Factor" values={sfValues} metric="safe_factor" decimals={2} suffix="×" />
      </div>
    </div>
  );
}
